<template>
  <div>
    <!-- 工具栏：输入框、查询、添加按钮 -->
    <el-row :gutter="20" class="toolbar">
      <el-col :span="6">
        <el-input v-model="searchKehu" placeholder="请输入客户标识"></el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" @click="loadData">查询</el-button>
        <el-button type="success" @click="handleAdd">添加</el-button>
      </el-col>
    </el-row>

    <!-- 数据表格 -->
    <el-table :data="tableData" style="width: 100%" v-loading="loading">
      <el-table-column prop="kehu" label="客户标识" width="150" />
      <el-table-column prop="reported" label="已上报数量" width="150" />
      <el-table-column prop="total" label="所有数据量" width="150" />
      <el-table-column label="上报率" width="120">
        <template slot-scope="scope">
          {{ calcRate(scope.row.reported, scope.row.total) }}%
        </template>
      </el-table-column>
      <el-table-column prop="upgl" label="设置的概率(%)" width="150" />
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 弹窗表单（添加 / 编辑） -->
    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle">
      <el-form :model="form">
        <el-form-item label="客户标识">
          <el-input v-model="form.kehu" />
        </el-form-item>
        <el-form-item label="设置概率(%)">
          <el-input v-model="form.upgl" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      searchKehu: '',
      tableData: [],
      loading: false,
      dialogVisible: false,
      dialogTitle: '添加客户',
      form: { id: null, kehu: '', upgl: '' }
    }
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        // 查询设置列表（包含 kehu 和 upgl）
        const ctrlRes = await axios.get('https://control.zjwec.cn/api/opct/list', {
          params: { kehu: this.searchKehu }
        })
        const ctrlList = ctrlRes.data || []

        // 获取 点击上报记录总表
        const monRes = await axios.get('https://control.zjwec.cn/api/oppoclick/list', {
          params: { kehu: this.searchKehu }
        })
        const monList = monRes.data || []

        // 合并数据，计算统计值
        this.tableData = ctrlList.map(ctrl => {
          const all = monList.filter(m => m.kehu === ctrl.kehu)
          const reported = all.filter(m => m.state === '1').length
          return {
            id: ctrl.id,
            kehu: ctrl.kehu,
            upgl: ctrl.upgl,
            total: all.length,
            reported
          }
        })
      } catch (err) {
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },
    calcRate(reported, total) {
      return total ? ((reported / total) * 100).toFixed(2) : '0.00'
    },
    handleAdd() {
      this.dialogTitle = '添加客户'
      this.form = { id: null, kehu: '', upgl: '' }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogTitle = '编辑客户'
      this.form = { id: row.id, kehu: row.kehu, upgl: row.upgl }
      this.dialogVisible = true
    },
    async handleDelete(row) {
      await axios.get('https://control.zjwec.cn/api/opct/delete', { params: { id: row.id } })
      this.$message.success('删除成功')
      this.loadData()
    },
    async submitForm() {
      if (this.form.id) {
        await axios.put('https://control.zjwec.cn/api/opct/update', this.form)
        await axios.get('https://control.zjwec.cn/api/oppoclick/deleteByKehu', {
          params: {
            kehu: this.form.kehu
          }
        });


        this.$message.success('更新成功')
      } else {
        await axios.post('https://control.zjwec.cn/api/opct/create', {
          kehu: this.form.kehu,
          upgl: this.form.upgl
        })
        this.$message.success('添加成功')
      }
      this.dialogVisible = false
      this.loadData()
    }
  },
  mounted() {
    this.loadData()
  }
}
</script>

<style scoped>
.toolbar {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/OppoCkDashboard.vue